/** Shared fetch helpers for service wrappers. */
export async function readError(res: Response): Promise<string> {
  try {
    const d = await res.json();
    return (d && (d.error || d.message)) || `HTTP ${res.status}`;
  } catch {
    return `HTTP ${res.status}`;
  }
}
